(function () {
  function openDetails(details) {
    if (!details) return;
    details.hidden = false;
    details.open = true;
  }

  function openHashTarget(root) {
    if (!window.location.hash) return;

    var target;
    try {
      target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    } catch (error) {
      return;
    }

    if (!target || !root.contains(target)) return;
    var details = target.matches('details') ? target : target.closest('details');
    openDetails(details);
  }

  document.querySelectorAll('[data-tg-support-page]').forEach(function (root) {
    root.querySelectorAll('[data-tg-flow]').forEach(function (flow) {
      var steps = Array.from(flow.querySelectorAll('[data-tg-flow-step]'));
      if (!steps.length) return;
      var count = flow.querySelector('[data-tg-flow-count]');
      var back = flow.querySelector('[data-tg-flow-back]');
      var reset = flow.querySelector('[data-tg-flow-reset]');
      var history = [steps[0].id];

      function show(id, moveFocus) {
        var active = null;
        steps.forEach(function (step) {
          var on = step.id === id;
          step.classList.toggle('is-active', on);
          if (on) active = step;
        });
        if (!active) return;
        root.querySelectorAll('[data-tg-reveal]').forEach(function (panel) {
          panel.open = false;
          panel.hidden = true;
        });
        if (count) count.textContent = active.getAttribute('data-tg-flow-label') || '';
        if (back) back.hidden = history.length < 2;
        if (reset) reset.hidden = history.length < 2;
        if (!moveFocus) return;
        var rect = flow.getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
          var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          flow.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
        var heading = active.querySelector('h3');
        if (heading) heading.focus({ preventScroll: true });
      }

      flow.addEventListener('click', function (event) {
        var link = event.target.closest('[data-tg-flow-go]');
        if (!link || !flow.contains(link)) return;
        var id = (link.getAttribute('href') || '').slice(1);
        if (!id || !document.getElementById(id)) return;
        event.preventDefault();
        history.push(id);
        show(id, true);
      });
      if (back) back.addEventListener('click', function () {
        if (history.length < 2) return;
        history.pop();
        show(history[history.length - 1], true);
      });
      if (reset) reset.addEventListener('click', function () {
        history = [steps[0].id];
        show(history[0], true);
      });

      flow.classList.add('is-ready');
      show(history[0], false);
    });

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link || link.hasAttribute('data-tg-flow-go')) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target || !root.contains(target)) return;
      var details = target.matches('details') ? target : target.closest('details');
      openDetails(details);
    });

    root.querySelectorAll('[data-tg-case-tab]').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('[data-tg-case-group]');
        if (!group) return;
        var key = button.getAttribute('data-tg-case-tab');

        group.querySelectorAll('[data-tg-case-tab]').forEach(function (item) {
          item.setAttribute('aria-selected', item === button ? 'true' : 'false');
          item.setAttribute('tabindex', item === button ? '0' : '-1');
        });
        group.querySelectorAll('[data-tg-case-panel]').forEach(function (panel) {
          var isActive = panel.getAttribute('data-tg-case-panel') === key;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });

      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        var group = button.closest('[data-tg-case-group]');
        if (!group) return;
        var tabs = Array.from(group.querySelectorAll('[data-tg-case-tab]'));
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = tabs[(tabs.indexOf(button) + direction + tabs.length) % tabs.length];
        event.preventDefault();
        next.click();
        next.focus();
      });
    });

    root.querySelectorAll('[data-tg-scroll-ai]').forEach(function (button) {
      button.addEventListener('click', function () {
        var intake = document.querySelector('[data-tg-support-intake]');
        var input = intake && intake.querySelector('[data-tg-si-input]');
        if (!intake || !input) return;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        intake.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(function () { input.focus(); }, 350);
      });
    });

    openHashTarget(root);
  });

  window.addEventListener('hashchange', function () {
    document.querySelectorAll('[data-tg-support-page]').forEach(openHashTarget);
  });
})();
